import PersonalReviewer from "../../PersonalReviewer.vue";
import TotalOrderLogsPopup from "../TotalOrderLogsPopup.vue";
import Cookies from "js-cookie";
import CookieKeys from "@/model/constants/cookieKeys";
import RadialProgressBar from "vue-radial-progress";
import SwitchAccount from "../SwitchAccount.vue";
import CartOrder from "../CartOrder.vue";
import CartOrderTransfer from "../CartOrderTransfer.vue";
import ProductListPage from "../ProductListPage";
import ProductVariantSelection from "../ProductVariantSelection";
import CartEntry from "../CartEntry";
import selfServiceStore from "@/store/selfService/selfService.js";
import {
  navigationQuestionForRedirect,
  getPosSettings,
} from "@/api/AppSettings";
import { getCategoryAndProduct } from "@/api/ProductCategory";
import { fetchUserWithCodes } from "@/api/User";
import { getCarts, addToCartFromCart, triggerKitchenPrintBySID, markAdisyonPrinted } from "@/api/Cart";
import { fetchLastBillId, changePassword, addDiscountLog } from "@/api/SelfService";
import { getPaymentMethodList } from "@/api/PaymentMethod";
import companyInfo from "../../../../model/constants/companyInfo";
import NewExpenseAddForSelfService from "../NewExpenseAddForSelfService.vue";
import TopOfTheDayScreen from "../TopOfTheDayScreen.vue";
import { isGranted } from "@/utils/auth";

import DayInterimScreen from "../DayInterimScreen.vue";
import {
  getIsDayOpening,
  getIsDayInterim,
  getBranchOpenClose,
  getRealTime,
  createDayOpen,
  createDayClose
} from "@/api/DayOpen.js";
import { getDayReportEnable } from "@/api/DayReportSetting";
import DayCloseScreen from "../DayCloseScreen.vue";
import SafeCashEntry from "../SafeCashEntry.vue";
import TableMap from "../TableMap.vue";
import {
  setBranchCart,
  reserveTable,
  unReserveTable,
  mergeCart,
  splitCart,
  transferCart,
  lockTable,
  releaseTable,
  releaseMyLocks,
} from "@/api/Cart";
import { uuid } from "vue-uuid";
import TableOperations from "../TableOperations.vue";
import Printer from "../Printer.vue";
import Kitchen from "../Kitchen.vue";
import { getPrinterSetting } from "@/api/PrinterSetting";
import OrderListPayment from "../OrderListPayment.vue";
import OrderListPaymentMobile from "../OrderListPaymentMobile.vue";
import { getKuverSetting } from "@/api/Kuver";
import { HubConnectionBuilder, LogLevel, HttpTransportType } from "@microsoft/signalr"; // Add this import
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import PaymentRequests from "../PaymentRequests.vue";
import CariPaymentModal from "../CariPaymentModal.vue";
export default {
  components: {
    ProductListPage,
    ProductVariantSelection,
    CartEntry,
    CartOrder,
    SwitchAccount,
    RadialProgressBar,
    TotalOrderLogsPopup,
    PersonalReviewer,
    NewExpenseAddForSelfService,
    TopOfTheDayScreen,
    DayInterimScreen,
    DayCloseScreen,
    SafeCashEntry,
    TableMap,
    TableOperations,
    VuePerfectScrollbar,
    Printer,
    Kitchen,
    CartOrderTransfer,
    OrderListPayment,
    OrderListPaymentMobile,
    PaymentRequests,
    CariPaymentModal
  },
  data() {
    return {
      showCartOrder: false,
      isSafeOperations: false,
      isPersonalReviewerActive: false,
      profileActionPage: 0,
      newUserCodeObj: {},
      isRequestActive: false,
      isAuth: false,
      isPosEnabled: false,
      isActiveChangePassword: false,
      toggleProfileActions: false,
      screenLock: true,
      cartEntry: null,
      productList: null,
      time: null,
      logo: companyInfo.logo,
      openClose: {},
      timerId: null,
      isDescriptionPromptActive: false,
      isDescriptionLoading: false,
      descriptionPromptText: "",
      descriptionPromptCallback: null,
      pendingDescription: "",
      isTimerEffect: false,
      dayReportIsEnable: false,
      showTableMap: true,
      selectedTable: null,
      isTableMove: false,
      isTableMerge: false,
      activeTab: "masalar",
      editMode: false,
      currentTabTemp: "masalar",
      isTableOperationsMobileActive: false,
      isAdisyonActive: false,
      moment: require("moment-timezone"),
      printeractive: false,
      orderBillEntries: [],
      totalOriginPrice: 0,
      totalDiscountPrice: 0,
      isExpanded: false,
      isTransferEntryActive: false,
      isPosSelectionActive: false,
      fromTableIdGlobal: null,
      toTableIdGlobal: null,
      isMobile: window.innerWidth <= 768,
      toTableName: "",
      orderBillNo: 0,
      isPaymentActive: false,
      connection: null,
      posData: {},
      isKuverPopupActive: false,
      kuverCount: 1,
      editOrderMode: false,
      selectedPaymentGroup: [],
      VUE_APP_POS_CLOUD: parseInt(process.env.VUE_APP_POS_CLOUD),
      isTransaction: false,
    };
  },
  computed: {
    currentCartGlobal: function () {
      const hostCart = this.$store.getters["selfservice/getCurrentCart"];
      if (!hostCart) return null;

      const areas = this.$store.getters["selfservice/getAreas"];
      const tables = areas.flatMap((area) => area.buttons);
      const tableGlobal = tables.find((t) => t.id === hostCart.tableId);
      let cartName = tableGlobal && tableGlobal.name;

      const carts = this.$store.getters["selfservice/getCarts"];
      // v118.Beta-Final-12.V3 [IMMUTABLE-ENTRY]: Veri kaynağını (Store) UI mutasyonlarından tamamen izole et
      let aggregatedEntries = JSON.parse(JSON.stringify(hostCart.cartEntries || []));
      let aggregatedPaymentGroups = JSON.parse(JSON.stringify(hostCart.paymentGroups || []));
      let aggregatedTotalPrice = hostCart.totalPrice || 0;

      if (hostCart.mergedIds && hostCart.mergedIds.length > 0) {
        const mergedNames = [];
        hostCart.mergedIds.forEach(id => {
          const mergedButton = tables.find((b) => b.id === id);
          if (mergedButton) mergedNames.push(mergedButton.name);

          const mCart = carts.find(c => c && c.id === id);
          if (mCart) {
            if (mCart.cartEntries) aggregatedEntries.push(...mCart.cartEntries);
            if (mCart.paymentGroups) aggregatedPaymentGroups.push(...mCart.paymentGroups);
            aggregatedTotalPrice += (mCart.totalPrice || 0);
          }
        });

        if (mergedNames.length > 0) {
          cartName += ` - ${mergedNames.join("-")}`;
        }
      }

      // v118.Beta-Final-12.V3 [IMMUTABLE]: Kütüphane verilerinin kirlenmemesi için tam izolasyon sağla
      const fixSteps = (entries) => {
        if (!entries) return [];
        // v118.V36 [GLOBAL-CANCELLATION-FILTER]: Hafıza kirliliğini engellemek için tüm iptal sebeplerini sepet genelinden topla
        const allForbiddenWords = (entries || []).reduce((acc, en) => {
          if (en && en.description) acc.add(en.description.trim().toLowerCase());
          if (en && en.note) acc.add(en.note.trim().toLowerCase());
          if (en && en.Note) acc.add(en.Note.trim().toLowerCase());
          return acc;
        }, new Set());

        return entries.map(entry => {
          const entryClone = JSON.parse(JSON.stringify(entry));
          const targetRecipe = entryClone.recipe || entryClone.Recipe || entryClone.recipeSteps || entryClone.RecipeSteps;
          
          if (targetRecipe && targetRecipe.steps) {
            // v118.V36 [STRICT-MATERIAL]: Silinebilir olanları veya özel eklenenleri (+buz vb.) listele (Deneme gibi sabit notları gizle)
            const filteredSteps = (targetRecipe.steps || targetRecipe.Steps || targetRecipe.recipeSteps || targetRecipe.RecipeSteps || []).filter(
              (x) => x && (x.name || x.Name || x.productName || x.ProductName) && 
                      (x.isRemovable || x.IsRemovable || (!(x.isDefault || x.IsDefault) && (x.selected || x.Selected)) || x.isRemoved || x.IsRemoved) &&
                      !allForbiddenWords.has((x.name || "").trim().toLowerCase())
            ).map(step => {
              const _isRemoved = !!(step.isRemoved || step.IsRemoved || step.is_removed || step.is_Removed || ((step.isDefault || step.IsDefault) && !(step.selected || step.Selected)));
              const rawMat = step.rawMaterial || step.RawMaterial || step.raw_material;
              const pName = step.productName || step.ProductName || (step.product && (step.product.name || step.product.Name));
              step.isRemoved = _isRemoved;
              step.name = (rawMat && (rawMat.name || rawMat.Name)) ? (rawMat.name || rawMat.Name) :
                (pName ? pName : (step.name || step.Name || "Malzeme"));
              return step;
            });
            entryClone.recipe = targetRecipe;
            entryClone.recipe.steps = filteredSteps;
          }
          return entryClone;
        });
      };

      aggregatedEntries = fixSteps(aggregatedEntries);
      aggregatedPaymentGroups = (aggregatedPaymentGroups || []).map(pg => {
        if (pg.entries) pg.entries = fixSteps(pg.entries);
        return pg;
      });

      // v117.Final Fix: Tüm finansal hesaplamaları burada yap ki yazıcı her zaman güncel veriyi görsün
      const allPayments = hostCart.orderPayments || [];
      if (hostCart.mergedIds && hostCart.mergedIds.length > 0) {
        hostCart.mergedIds.forEach(id => {
          const mCart = carts.find(c => c && c.id === id);
          if (mCart && mCart.orderPayments) allPayments.push(...mCart.orderPayments);
        });
      }

      // 1. Brüt Tutar (OriginPrice toplamı)
      const totalOriginPrice = aggregatedEntries.reduce((total, entry) => {
        // v118.V5 [STABLE-SUBTOTAL]: originPrice yoksa price'ı baz alarak ara toplamı koru
        const op = parseFloat(entry.originPrice || entry.OriginPrice || entry.price || entry.Price || 0);
        return total + (op * (entry.quantity || 1));
      }, 0);

      // 2. Gerçek Nakit/Kredi Ödemeleri
      const realPaymentsTotal = allPayments.reduce((total, p) => {
        const mId = p.paymentMethodId || (p.paymentMethod ? (p.paymentMethod.id || p.paymentMethod.Id) : 0);
        if (mId != 4 && mId != 15) return total + (parseFloat(p.price) || 0);
        return total;
      }, 0);

      // 3. İndirim Ödemeleri (Payment Method 4 veya 15)
      const paymentDiscounts = allPayments.reduce((total, p) => {
        const mId = p.paymentMethodId || (p.paymentMethod ? (p.paymentMethod.id || p.paymentMethod.Id) : 0);
        if (mId == 4 || mId == 15) return total + (parseFloat(p.price) || 0);
        return total;
      }, 0);

      // 4. Sepet Bazlı İndirimler (Store verisinden)
      const basketDiscounts = (hostCart.discounts || []).reduce((total, d) => {
        return total + (parseFloat(d.priceToDiscount || d.price || d.value || 0));
      }, 0);

      // 5. Güncel Bakiye (Ödeme gruplarındaki net bakiye - Adisyon popup'ıyla tam uyum için)
      const currentBalance = (aggregatedPaymentGroups || []).reduce((total, group) => {
        return total + (parseFloat(group.totalPrice || 0) - parseFloat(group.payedPrice || 0));
      }, 0);

      // v118.V35 [STABLE-DISCOUNT]: İndirimi hesapla (Ara Toplam - Para Ödemeleri - Kalan = Toplam İndirim)
      // Bu hesaplama hem ürün bazlı indirimleri hem de ödeme yöntemi olarak girilen (Kampanya/İndirim) indirimleri kapsar.
      const totalDiscountPrice = Math.max(0, Math.round((totalOriginPrice - realPaymentsTotal - currentBalance) * 100) / 100);
      const netTotalPrice = Math.round((totalOriginPrice - totalDiscountPrice) * 100) / 100;

      return {
        ...hostCart,
        cartEntries: aggregatedEntries,
        paymentGroups: aggregatedPaymentGroups,
        orderPayments: allPayments,
        totalPrice: netTotalPrice,
        totalOriginPrice: Math.round(totalOriginPrice * 100) / 100,
        totalDiscountPrice: totalDiscountPrice,
        totalPayedPrice: Math.round((realPaymentsTotal + paymentDiscounts + totalDiscountPrice) * 100) / 100, // Brüt ödeme (Indirim dahil)
        realPaymentsTotal: Math.round(realPaymentsTotal * 100) / 100, // Net ödeme (Sadece para)
        leftPrice: Math.round(Math.max(0, currentBalance) * 100) / 100,
        cartName
      };
    },
    isAddLoss() {
      return isGranted("discount_loss_create");
    },
    isLoading: {
      get() {
        return this.$store.getters["selfservice/getIsLoading"];
      },
      set(val) {
        this.$store.dispatch("selfservice/setIsLoading", val);
      },
    },
    isReset: {
      get() {
        return this.$store.getters["selfservice/getToIsReset"];
      },
      set(val) {
        this.$store.dispatch("selfservice/setIsReset", val);
      },
    },
    isActiveTotalOrderLogs: {
      get() {
        return this.$refs.totalOrderLogsPopup.isActive;
      },
      set(val) {
        this.$refs.totalOrderLogsPopup.isActive = val;
      },
    },
    lossMode: {
      get() {
        return this.$store.getters["selfservice/getLossMode"];
      },
      set(val) {
        this.$store.dispatch("selfservice/setLossMode", val);
      },
    },
    toUpdateEntry() {
      return this.$store.getters["selfservice/getToUpdateEntry"];
    },
    isProductVariantSelectionOpen: {
      get() {
        return this.$refs.variantSelection
          ? this.$refs.variantSelection.isProductVariantSelectionOpen
          : null;
      },
      set(val) {
        this.$refs.variantSelection.isProductVariantSelectionOpen = val;
      },
    },
    preSelectedProduct() {
      return this.$store.getters["selfservice/getPreSelectedProduct"];
    },
    selectedProduct() {
      return this.$store.getters["selfservice/getSelectedProduct"];
    },
    isScreenLock: {
      get() {
        return this.$store.getters["selfservice/getScreenLock"];
      },
      set(val) {
        this.$store.dispatch("selfservice/setScreenLock", val);
      },
    },
    isTopDay: {
      get() {
        return true;
      },
      set() {
        // this.$store.dispatch("selfservice/setScreenLock", val);
      },
    },
    activePersonal: {
      get() {
        let personal = this.$store.getters["selfservice/getActivePersonal"];
        console.log("activePersonel getter:", personal);

        // Eğer activePersonal null ise ve switch gizliyse, current user'ı kullan
        if (!personal && this.notSwitchQuery) {
          let userInfo = JSON.parse(localStorage.getItem("userInfo"));
          console.log("userInfo from localStorage:", userInfo);

          if (userInfo) {
            this.$store.dispatch("selfservice/setActivePersonal", userInfo);
            return userInfo;
          }
        }
        return personal;
      },
      set(val) {
        this.$store.dispatch("selfservice/setActivePersonal", val);
      },
    },
    isAdminActivePersonal() {
      const user = this.activePersonal || this.$store.state.AppActiveUser;
      return user && user.role && user.role.some((x) => x.name == "admin");
    },
    // Barista (sistemde "user" rolü) ve Barmen rolündeki personel Anasayfa butonunu görmez
    isHomeButtonVisible() {
      const user = this.activePersonal || this.$store.state.AppActiveUser;
      const hiddenRoles = ["user", "barmen", "barista"];
      return !(user && user.role && user.role.some((x) => hiddenRoles.includes((x.name || "").toLowerCase())));
    },
    areas() {
      return this.$store.getters["selfservice/getAreas"];
    },
    currentTab() {
      return this.$store.getters["selfservice/getCurrentTab"];
    },
    currentDate() {
      let date = this.moment().locale("tr");
      date = date.tz("Europe/Istanbul").format("ddd Do MMM");
      return date;
    },
    currentTime() {
      let time = this.moment().locale("tr");
      time = time.tz("Europe/Istanbul").format("HH:mm");
      return time;
    },
    printerSettings() {
      return this.$store.getters["selfservice/getPrinterSettings"];
    },
    getSelectedPosName() {
      if (!this.posData || !this.posData.subPosSettings) return '';
      const selectedPos = this.posData.subPosSettings.find(
        pos => pos.id === this.getSelectedPosId
      );
      return selectedPos ? selectedPos.name : '';
    },
    getSelectedPosId() {
      return this.$store.getters['selfservice/getSelectedPosId'];
    },
    kuverSettings() {
      return this.$store.getters["selfservice/getKuverSettings"];
    },
    mainScrollSettings() {
      return {
        wheelSpeed: this.isMobile ? 0.6 : 1,
        swipeEasing: true,
        maxScrollbarLength: 100,
        wheelPropagation: false,
      };
    },
    mainContentState() {
      if (this.showTableMap) return "table-map";
      if (this.preSelectedProduct != null) return "variant-selection";
      if (this.toUpdateEntry != null || this.selectedProduct != null) return "cart-entry";
      if (this.productList != null) return "product-list";
      return "unknown";
    }
  },
  watch: {
    isTransferEntryActive: {
      handler(value) {
        this.transferTable(value);
      },
      deep: true,
    },
    activeTab: {
      handler(newValue) {
        if (newValue == "masalar") {
          this.showTableMap = true;
          this.$store.dispatch("selfservice/setCurrentTab", "masalar");
          this.currentTabTemp = "masalar";
        }
        if (newValue == "odeme") {
          this.showTableMap = true;
          this.$store.dispatch("selfservice/setCurrentTab", "odeme");
          this.currentTabTemp = "odeme";
        }
        if (newValue == "menu") {
          this.$store.dispatch("selfservice/setCurrentTab", "menu");
          this.currentTabTemp = "menu";
          this.showTableMap = false;
        }
      },
      deep: true,
    },
    profileActionPage(newVal, oldVal) {
      if (newVal < 0 || newVal > 1) this.profileActionPage = oldVal;
    },
    isActiveChangePassword() {
      this.newUserCodeObj = {};
    },
    preSelectedProduct: function (val) {
      if (val != null) {
        this.isProductVariantSelectionOpen = true;
      } else {
        this.isProductVariantSelectionOpen = false;
      }
    },
    mainContentState(newVal, oldVal) {
      const shouldResetToTop = oldVal === "product-list" && newVal === "cart-entry";
      this.refreshMainScroll({ resetToTop: shouldResetToTop });
    },
    selectedProduct() {
      this.refreshMainScroll();
    },
    toUpdateEntry() {
      this.refreshMainScroll();
    },
    productList() {
      this.refreshMainScroll();
    },
    lossMode() {
      this.isReset = true;
      this.refreshMainScroll();
    },
  },
  methods: {
    getPerfectScrollbarElement(refName) {
      const scrollRef = this.$refs[refName];
      if (!scrollRef) return null;
      return scrollRef.$el || scrollRef;
    },
    refreshMainScroll({ resetToTop = false } = {}) {
      this.$nextTick(() => {
        requestAnimationFrame(() => {
          const scrollRef = this.$refs.mainSaleScrollbar;
          const scrollEl = this.getPerfectScrollbarElement("mainSaleScrollbar");
          if (!scrollRef || !scrollEl) return;

          if (typeof scrollRef.update === "function") {
            scrollRef.update();
          }
          if (scrollRef.ps && typeof scrollRef.ps.update === "function") {
            scrollRef.ps.update();
          }

          if (resetToTop) {
            scrollEl.scrollTop = 0;
          }
        });
      });
    },
    handleKuverPopupClose() {
      this.kuverCount = 1; // Kuver sayısını resetle
      this.showTableMap = true;
    },
    handleKuverConfirm: async function () {
      if (this.isTransaction) return;
      try {
        this.isTransaction = true;
        this.isKuverPopupActive = false;
        var carts = this.$store.getters["selfservice/getCarts"];
        let toUpdateCart = carts.find(
          (x) => x != null && x.id == this.selectedTable.id
        );
        console.log("toUpdateCart", toUpdateCart);
        let kuverPrice = this.kuverSettings.unitPrice * this.kuverCount;

        // Yeni kuver entry'si oluştur
        let newGuid = uuid.v1();
        const kuverEntry = {
          productId: this.kuverSettings.productId,
          childProductId: 0,
          productName: "Kuver",
          productQuantity: Number(this.kuverCount),
          quantity: Number(this.kuverCount),
          price: kuverPrice,
          recipe: { id: this.kuverSettings.productId, steps: [] },
          originPrice: kuverPrice,
          totalPrice: kuverPrice,
          payedPrice: 0,
          rowIndex: newGuid,
          note: `${this.kuverCount} kişilik kuver`,
          extras: [],
          id: newGuid,
          kdv: 20,
          status: 0 // v118: Set status to Waiting
        };
        console.log(kuverEntry);

        let payloadCart = Object.assign({}, toUpdateCart);
        payloadCart.entries = payloadCart.entries ? [...payloadCart.entries, kuverEntry] : [kuverEntry];
        payloadCart.cartEntries = payloadCart.cartEntries ? [...payloadCart.cartEntries, kuverEntry] : [kuverEntry];
        payloadCart.printerActive = this.printerSettings.enable;
        payloadCart.printerName = this.printerSettings.mainPrinterName;
        payloadCart.branchName = this.$store.state.AppActiveUser.branch.name;

        if (!payloadCart.paymentGroups) {
          payloadCart.paymentGroups = [];
        }
        const newPaymentGroup = {
          rowIndex: kuverEntry.rowIndex,
          payedPrice: 0,
          entries: [kuverEntry],
          totalPrice: kuverPrice,
          status: "Kalan"
        };
        payloadCart.paymentGroups = [...payloadCart.paymentGroups, newPaymentGroup];

        console.log(payloadCart);
        payloadCart.totalPrice = (payloadCart.totalPrice || 0) + kuverPrice;
        payloadCart.isFullTable = true;
        payloadCart.totalPayedPrice = 0;

        this.$store.dispatch('selfservice/updateCartsById', [payloadCart]);
        
        // v118.Alpha-Final-34: ONLY send the new kuver entry to the backend to avoid double-adding existing items
        let backendPayload = {
          ...payloadCart,
          id: 0,
          tableId: payloadCart.realId || payloadCart.tableId || 0,
          entries: [kuverEntry],
          cartEntries: [kuverEntry],
          paymentGroups: [newPaymentGroup]
        };

        var result = await addToCartFromCart(
          backendPayload,
          (backendPayload.tableId || backendPayload.realId || backendPayload.id)
        );

        this.orderBillNo = result.data;
      } catch (err) {
        console.error("Kuver hatası:", err);
      } finally {
        this.isTransaction = false;
      }
    },
    handleVisibilityChange() {
      if (!document.hidden) {
        this.manualRefresh();
      }
    },
    manualRefresh() {
      if (this.$refs.tableMap) {
        this.$refs.tableMap.fetchAreas();
      }
    },
    goToHome() {
      this.$router.push("/");
    },
    getCurrentTime() {
      this.currentTime = this.moment().locale("tr");
      this.currentTime = this.currentTime
        .tz("Europe/Istanbul")
        .format("H:mm:ss");
      setTimeout(this.getCurrentTime, 1000);
    },
    PlaceOrder: async function () {
      this.orderBillEntries = [];
      this.totalDiscountPrice = 0;
      this.totalOriginPrice = 0;
      
      // v118.Alpha-Final-35: Filter only new/waiting entries for printer/pre-order preview
      const pendingEntries = (this.currentCartGlobal.cartEntries || []).filter(x => x.status === 0);

      pendingEntries.forEach((tr) => {
        // v118.Beta-Final-2: tr.price zaten miktar dahil (Line Total) bir fiyattır.
        // Bu yüzden tekrar miktar ile ÇARPMIYORUZ.
        const lineTotal = parseFloat(tr.price) || 0;
        const lineOriginTotal = parseFloat(tr.originPrice || tr.price) || 0;
        
        this.totalPrice += lineTotal;
        this.totalOriginPrice += lineOriginTotal;

        this.orderBillEntries.push({
          productId: tr.productId,
          childProductId: tr.childProductId,
          productQuantity: tr.quantity,
          quantity: tr.quantity,
          productName: tr.productName,
          // v118.Beta-Final-8: Kesin İzolasyon -> Reçeteyi kopyalayarak 'Ghost Ingredient' sızıntısını engelle
          recipe: tr.recipe ? _.cloneDeep(tr.recipe) : null,
          steps: tr.recipe && tr.recipe.steps ? _.cloneDeep(tr.recipe.steps) : [],
          recipeSteps: tr.recipe && tr.recipe.steps ? _.cloneDeep(tr.recipe.steps) : [],
          variantItems: tr.recipe && tr.recipe.steps ? tr.recipe.steps.filter(
            (x) => x.selected == true && x.isDefault == false
          ) : [],
          extras: tr.extras,
          // v118.Beta-Final-3: Printer ve Ödeme ekranı için SATIR TOPLAMI (Line Total) gönderiyoruz.
          // Backend/Terminal App kendi içinde birim fiyata bölebilir veya biz Terminal App'e giderken bölebiliriz.
          price: lineTotal, 
          originPrice: lineOriginTotal,
          rawProduct: tr.rawProduct,
          note: tr.note,
          id: tr.id
        });
      });
      if (!this.lossMode) {
        if (this.isMobile) {
          this.$refs.orderListPaymentMobile.orderBillEntries = this.orderBillEntries;
        } else {
          this.$refs.orderListPayment.orderBillEntries = this.orderBillEntries;
        }
      }
    },
    startMoveTable(fromTableId, toTableId) {
      var table = this.areas
        .flatMap((area) => area.buttons)
        .find((button) => button.id === fromTableId);

      var carts = this.$store.getters["selfservice/getCarts"];
      // Mevcut cart'ların içinde ilgili tableId var mı diye kontrol et
      const existingCart = carts.find(
        (cart) => cart != null && cart.tableId === fromTableId
      );

      if (existingCart) {
        // Eğer bu masa için zaten bir cart varsa, onu current cart olarak ayarla
        this.fromTableIdGlobal = fromTableId;
        this.toTableIdGlobal = toTableId;
        existingCart.name = table.name;
        this.$store.dispatch("selfservice/setCurrentCart", existingCart);
        this.$store.dispatch("selfservice/setToUpdateEntry", null);
        this.$store.dispatch("selfservice/setCakeQuestioned", false);

        const targetTable = this.areas
          .flatMap((area) => area.buttons)
          .find((button) => button.id === toTableId);
        this.toTableName = targetTable.name;
      }
      this.isTransferEntryActive = true;
    },
    async completeTransfer(rows) {
      this.showDescriptionPrompt("Ürün transferi için lütfen bir açıklama giriniz.", async (description) => {
        if (this.isTransaction) return;
        try {
          this.isTransaction = true;
          // Transfer edilen items ID'lerini al (rows zaten aktarılanların rowIndex'leri)
          await addDiscountLog({
            tableId: this.toTableIdGlobal,
            ids: rows || [],
            totalDiscount: 0,
            discountType: "Transfer",
            actionType: "Transfer",
            description: description
          });

          await transferCart(
            this.fromTableIdGlobal,
            this.toTableIdGlobal,
            rows,
            description
          );
          let carts = (await getCarts()).data;
          if (carts.length > 0) {
            this.$store.dispatch("selfservice/setToCart", carts);
          }
          await this.refreshBranchMap();
          this.isTransferEntryActive = false;
          this.$store.dispatch("selfservice/setIsTableMove", false);
          this.isTableMove = false;
          this.$vs.notify({
            color: "success",
            title: "Yenilendi",
            text: "Transfer Tamamlandı.",
          });
        } catch (error) {
          console.error("Transfer hatası:", error);
        } finally {
          this.isTransaction = false;
        }
      });
    },
    toggleExpand() {
      this.isExpanded = !this.isExpanded;
      if (this.isExpanded) {
        this.$refs.cartOrderBottomSheet.tableHeight = "100% !important";
      } else {
        this.$refs.cartOrderBottomSheet.tableHeight = "auto !important";
      }
    },
    returnSelectedExtraVariant(extra) {
      let returnObj = [];
      extra.variants.forEach((x) => {
        returnObj.push("x" + x.quantity + " / " + x.name);
      });
      return returnObj.length > 0 ? returnObj : null;
    },
    toggleTableOperationsMobile() {
      this.isTableOperationsMobileActive = !this.isTableOperationsMobileActive;
    },
    refreshBranchMap() {
      // For example, you might want to re-fetch the table data:

      this.$refs.tableMap.fetchAreas();
      // Or maybe reset some state:
      this.selectedTable = null;
      // You might also want to notify the user:
      this.$vs.notify({
        color: "success",
        title: "Yenilendi",
        text: "Masa haritası yenilendi.",
      });
    },
    editModeOn() {
      this.$vs.notify({
        color: "success",
        title: "Düzenleme Modu Aktif",
        text: "Düzenleme modu aktif edildi.",
      });
      this.editMode = true;
    },
    editModeOff() {
      this.$vs.notify({
        color: "success",
        title: "Düzenleme Modu Kapatıldı",
        text: "Düzenleme modu kapatıldı.",
      });
      this.editMode = false;
    },
    getOpenClose: async function () {
      this.openClose = (await getBranchOpenClose()).data;
    },
    dayCloseClick() {
      // Gün sonu raporu pasif ise işlem yapma
      if (!this.dayReportIsEnable) {
        // Pasif ise notification göster ve devam et
        this.$vs.notify({
          color: 'warning',
          title: 'Bilgi',
          text: 'Bu şube için gün sonu raporu pasiftir.'
        });
        return;
      }
      
      this.$refs.dayclosescreenref.isOldClose = false;
      this.$refs.dayclosescreenref.isActive = true;
      // clearInterval(this.timerId)
    },
    async checkAndStartSilentDay() {
      try {
        const isDayOpening = await getIsDayOpening();
        const activeUser = this.$store.state.AppActiveUser;
        const userData = {
          safeCash: 0,
          userId: activeUser.id,
          userName: activeUser.name,
          nextDayCash: 0,
          xReportForCard: 0
        };

        if (isDayOpening.data == 0) {
          console.log("[SilentDay] Başlatılmamış gün tespit edildi, açılıyor...");
          await createDayOpen(userData);
          await this.getOpenClose();
        } else if (isDayOpening.data == 1) {
          console.log("[SilentDay] Kapatılmamış gün tespit edildi, kapatılıp yenisi açılıyor...");
          await createDayClose(userData);
          await createDayOpen(userData);
          await this.getOpenClose();
        }
      } catch (error) {
        console.error("[SilentDay] Hata:", error);
      }
    },
    checkClosingTime: async function () {
      await this.getOpenClose();
      var remoteDate = await getRealTime();
      const currentTime = new Date(remoteDate.data);
      const currentTimeMinutes =
        currentTime.getHours() * 60 + currentTime.getMinutes();
      const targetTimeMinutes =
        parseInt(this.openClose.closeTime.split(":")[0]) * 60 +
        parseInt(this.openClose.closeTime.split(":")[1]);
      let timeDifference = targetTimeMinutes - currentTimeMinutes;
      let closeTime = new Date(this.openClose.openDate);
      let openTime = new Date(this.openClose.openDate);
      closeTime.setHours(
        parseInt(this.openClose.closeTime.split(":")[0]),
        parseInt(this.openClose.closeTime.split(":")[1]),
        0
      );
      openTime.setHours(
        parseInt(this.openClose.openTime.split(":")[0]),
        parseInt(this.openClose.openTime.split(":")[1]),
        0
      );

      if (openTime.getTime() > closeTime.getTime()) {
        // Eğer kapanış saati 24'ten sonrasa, hedef zamanı bir sonraki gün olarak ayarla
        closeTime.setDate(currentTime.getDate() + 1);
      }
      timeDifference = closeTime.getTime() - currentTime.getTime();
      if (timeDifference <= 600000) {
        // Kapatma saati yaklaşıyor, popup'ı göster
        this.isTimerEffect = true;
      } else {
        // Kapatma saati uzak, popup'ı gizle
        this.isTimerEffect = false;
      }
    },
    emitCloseReportSelfService(result) {
      if (result) {
        this.$refs.topofthedayscreenref.isActive = true;
      }
    },
    emitDisableSelfService(result) {
      if (result) {
        // document.getElementById('araRaporButton').disabled = true;
      }
    },
    saveExpense(payload) {
      this.$store.dispatch("expense/addExpense", payload).catch((error) => {
        this.$vs.notify({
          color: "danger",
          title: "Hata",
          text: error,
        });
      });
    },
    addNewExpense() {
      this.$refs.newExpenseAdd.isActive = true;
    },
    toggleDropdown() {
      this.isSafeOperations = !this.isSafeOperations;
    },
    getAvatar(image) {
      if (image == "") return this.logo;
      else return this.$baseUrl + "/" + image;
    },
    resetProfileSelection() {
      this.toggleProfileActions = false;
      this.profileActionPage = 0;
    },
    changePassword: async function () {
      let check = await this.$validator.validateAll();
      if (!check) return;
      if (this.activePersonal.userCode != this.newUserCodeObj.oldCode) {
        this.$fire({
          title: "Hata !",
          text: "Eski Kod Aktif Kullanıcının Kodu ile Eşleşmiyor !",
          type: "error",
        });
        this.$vs.notify({
          color: "danger",
          title: "Hata !",
          text: "Eski Kod Aktif Kullanıcının Kodu ile Eşleşmiyor !",
        });
      } else {
        changePassword({
          userId: this.activePersonal.id,
          userCode: this.newUserCodeObj.newCode,
        })
          .then((res) => {
            if (res && res.status == 200) {
              this.$vs.notify({
                color: "success",
                title: "Kod Başarıyla Değiştirildi !",
                text: "Yeni Kod Kullanıma Hazır.",
              });
              this.isActiveChangePassword = false;
              this.$store.dispatch(
                "selfservice/setActivePersonalUserCode",
                this.newUserCodeObj.newCode
              );
            }
          })
          .catch(() => {
            this.$fire({
              title: "Hata !",
              text: "Kod Değiştirme Başarısız !",
              type: "error",
            });
            this.$vs.notify({
              color: "danger",
              title: "Hata !",
              text: "Kod Değiştirme Başarısız !",
            });
          });
      }
    },
    doExit() {
      //let userDetails = Cookies.get(CookieKeys.USER_DETAILS)
      //if(USER_DETAILS.rols.some(x=> x.name == Roles.admin))
      //this.$router.push('/');
      //else {
      this.isTableOperationsMobileActive = false;
      this.$router.push("/pages/login");

      // }
      // document.exitFullscreen();
    },
    screenLockToggle() {
      this.activePersonal = null;
    },
    onSelectProduct(val) {
      this.preSelectedProduct = val;
      this.isProductVariantSelectionOpen = true;
    },
    productSelectionCompleted: function (val) {
      this.cartEntry = val;
      // this.$store.dispatch("productSelectionCompleted",true);
      //Add To Cart
      this.isProductVariantSelectionOpen = false;
      this.$store.dispatch("selfservice/setPreSelectedProduct", null);
    },
    closeProductSelection: function () {
      this.isProductVariantSelectionOpen = false;
    },
    fetchKuverSettings: async function () {
      let response = await getKuverSetting();
      this.$store.dispatch("selfservice/setKuverSettings", response.data);
    },
    fetchCategories: async function () {
      try {
        this.productList = await getCategoryAndProduct();
      } catch (e) {
        this.productList = null;
        this.$fire({
          title: "Hata !",
          text: e.message,
          type: "error",
        });
        this.$vs.notify({
          color: "danger",
          title: "Hata !",
          text: e.message,
        });
      }
    },
    fetchUsers: async function () {
      try {
        let response = await fetchUserWithCodes();
        this.$store.dispatch("selfservice/setPersonList", response);
      } catch (e) {
        this.$store.dispatch("selfservice/setPersonList", null);
        this.$fire({
          title: "Hata !",
          text: e.message,
          type: "error",
        });
        this.$vs.notify({
          color: "danger",
          title: "Hata !",
          text: e.message,
        });
      }
    },
    fetchLastBillId: async function () {
      try {
        let response = await fetchLastBillId();
        this.$store.dispatch("selfservice/setLastBillId", response + 1);
      } catch (e) {
        this.$store.dispatch("selfservice/setLastBillId", null);
        this.$fire({
          title: "Hata !",
          text: e.message,
          type: "error",
        });
        this.$vs.notify({
          color: "danger",
          title: "Hata !",
          text: e.message,
        });
      }
    },
    getPaymentMethodList: async function () {
      try {
        let response = await getPaymentMethodList();
        if (response && response.length) {
          const creditCard = response.find(m => m.id == process.env.VUE_APP_CREDIT_PAYMENT_ID);
          if (creditCard) {
            response.forEach(m => m.selected = (m.id == process.env.VUE_APP_CREDIT_PAYMENT_ID));
          } else {
            response[0].selected = true;
          }
        }
        this.$store.dispatch("selfservice/setPaymentMethods", response);
      } catch (e) {
        this.$fire({
          title: "Hata !",
          text: e.message,
          type: "error",
        });
        this.$vs.notify({
          color: "danger",
          title: "Hata !",
          text: e.message,
        });
      }
    },
    inactivityTime() {
      window.onload = this.resetTimer;
      document.onmousemove = this.resetTimer;
      document.onkeypress = this.resetTimer;
      document.onclick = this.resetTimer;
    },
    resetTimer() {
      if (this.activePersonal !== null) {
        clearTimeout(this.time);
        this.time = setTimeout(this.screenLockToggle, this.$afkTimeOut);
      }
    },
    getNavigationQuestionForSale: async function () {
      try {
        let response = await navigationQuestionForRedirect();
        this.$store.dispatch("selfservice/setNavigationQuestion", response);
      } catch (e) {
        this.$store.dispatch("selfservice/setNavigationQuestion", null);
        this.$fire({
          title: "Hata !",
          text: e.message,
          type: "error",
        });
        this.$vs.notify({
          color: "danger",
          title: "Hata !",
          text: e.message,
        });
      }
    },
    connectPos: async function (loadScreen) {
      this.isRequestActive = true;
      this.isLoading = loadScreen;
      await fetch(process.env.VUE_APP_POS_API + "pair", {
        method: "post",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      })
        .then((response) => response.json())
        .then((res) => {
          this.isRequestActive = false;
          this.isLoading = false;
          if (res.hasError == false || res.statusCode == 200) {
            this.$vs.notify({
              color: "success",
              title: "Pos Cihazına Bağlanıldı.",
              text: "",
            });
          } else if (res.message.includes("Cihaz Bağlantısı yapıldı")) {
            this.$vs.notify({
              color: "success",
              title: "Pos Cihaz Bağlantısı Yapıldı!",
              text: res.message,
            });
          } else {
            this.$fire({
              title: "Hata !",
              text: "Pos Cihaz Bağlantısı Yapılamadı !",
              type: "error",
            });
            this.$vs.notify({
              color: "danger",
              title: "Pos Cihaz Bağlantısı Yapılamadı !",
              text: res.message,
            });
          }
        })
        .catch(() => {
          this.isRequestActive = false;
          this.isLoading = false;
          this.$fire({
            title: "Hata !",
            text: "Pos Cihaz Bağlantısı Yapılamadı !",
            type: "error",
          });
          this.$vs.notify({
            color: "danger",
            title: "Hata !",
            text: "Pos Cihaz Bağlantısı Yapılamadı !",
          });
        });
    },
    checkPosDevice: async function () {
      let userInfo = JSON.parse(localStorage.getItem("userInfo"));
      if (!userInfo) {
        this.$router.push("/");
      }
      let branchId = await userInfo.branch.id;
      let axiosResponse = await getPosSettings(branchId);
      localStorage.setItem("posSettings", JSON.stringify(axiosResponse.data));
      this.isPosEnabled = axiosResponse.data.enable;
      this.posData = axiosResponse.data;
    },
    handleTableSelection: async function (data) {
      // Masa seçildiğinde yapılacak işlemler
      if (!data) {
        return;
      }
      const id = data.id;
      const number = data.number;
      if (this.isTableMove) {
        let currentCart = this.$store.getters["selfservice/getCurrentCart"];
        
        // Aynı masayı kendisine taşımayı engelle
        if (currentCart && (currentCart.tableId === id || currentCart.realId === id)) {
          this.$vs.notify({
            color: "warning",
            title: "Hata",
            text: "Bir masayı kendisine taşıyamazsınız!",
          });
          this.moveTableModeDeactive();
          return;
        }

        const allButtons = this.areas ? this.areas.flatMap((area) => area.buttons) : [];
        const sourceTable = allButtons.find(b => b.id === currentCart.tableId);
        const sourceTableName = sourceTable ? sourceTable.name : (currentCart.name || currentCart.tableNumber || 'Bilinmeyen');

        this.$fire({
          title: "Masa Taşıma",
          text: `${sourceTableName} numaralı masayı ${number} numaralı masaya taşımak istediğinize emin misiniz?`,
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Evet, Taşı",
          cancelButtonText: "İptal",
        }).then(async (result) => {
          if (result.value) {
            this.showDescriptionPrompt("Masa taşıma işlemi için lütfen bir açıklama giriniz.", async (description) => {
              var carts = this.$store.getters["selfservice/getCarts"];
              let moveCart = carts.find((cart) => cart.tableId === id);

              if (moveCart) {
                // Get all IDs before clearing the current cart
                const allIds = currentCart.paymentGroups ? currentCart.paymentGroups.map(pg => pg.rowIndex).filter(id => id != null) : [];

                let clonedMoveCart = _.cloneDeep(moveCart);
                let clonedCurrentCart = _.cloneDeep(currentCart);

                if (clonedCurrentCart.cartEntries && clonedMoveCart.cartEntries) {
                  clonedMoveCart.cartEntries = clonedMoveCart.cartEntries.concat(
                    _.cloneDeep(clonedCurrentCart.cartEntries)
                  );
                } else if (clonedCurrentCart.cartEntries) {
                  clonedMoveCart.cartEntries = _.cloneDeep(clonedCurrentCart.cartEntries);
                }

                if (clonedCurrentCart.paymentGroups && clonedMoveCart.paymentGroups) {
                  clonedMoveCart.paymentGroups = clonedMoveCart.paymentGroups.concat(
                    _.cloneDeep(clonedCurrentCart.paymentGroups)
                  );
                } else if (clonedCurrentCart.paymentGroups) {
                  clonedMoveCart.paymentGroups = _.cloneDeep(clonedCurrentCart.paymentGroups);
                }

                if (clonedCurrentCart.orderPayments && clonedMoveCart.orderPayments) {
                  clonedMoveCart.orderPayments = clonedMoveCart.orderPayments.concat(
                    _.cloneDeep(clonedCurrentCart.orderPayments)
                  );
                } else if (clonedCurrentCart.orderPayments) {
                  clonedMoveCart.orderPayments = _.cloneDeep(clonedCurrentCart.orderPayments);
                }
                clonedMoveCart.totalPrice += clonedCurrentCart.totalPrice;
                clonedMoveCart.totalPayedPrice += clonedCurrentCart.totalPayedPrice;

                // Referans değeri korunması için null yerine boş dizi atanıyor
                if (clonedCurrentCart.cartEntries) clonedCurrentCart.cartEntries = [];
                if (clonedCurrentCart.paymentGroups)
                  clonedCurrentCart.paymentGroups = [];
                if (clonedCurrentCart.orderPayments)
                  clonedCurrentCart.orderPayments = [];
                clonedCurrentCart.totalPrice = 0;
                clonedCurrentCart.totalPayedPrice = 0;

                this.$store.dispatch('selfservice/updateCartsById', [clonedMoveCart, clonedCurrentCart]);
                this.$store.dispatch("selfservice/removeCart", clonedCurrentCart.id);

                await transferCart(clonedCurrentCart.tableId, clonedMoveCart.tableId, allIds, description);
                this.$vs.notify({
                  color: "success",
                  title: "Masa Taşındı",
                  text: `${sourceTableName} numaralı masa ${number} numaralı masaya başarıyla taşındı.`,
                });
                this.moveTableModeDeactive();
                this.$store.dispatch("selfservice/setCurrentCart", moveCart);
                this.selectedTable = { id, number };
                this.showTableMap = false; // Ürün listesine geç
              } else {
                // Get all IDs before clearing the current cart
                const allIds = currentCart.paymentGroups ? currentCart.paymentGroups.map(pg => pg.rowIndex).filter(id => id != null) : [];

                let newCart = {
                  id: number,
                  cartEntries: [...currentCart.cartEntries],
                  orderPayments: [...currentCart.orderPayments],
                  totalPrice: currentCart.totalPrice,
                  totalPayedPrice: currentCart.totalPayedPrice,
                  active: true,
                  tableId: id,
                  tableNumber: number,
                  paymentGroups: [...currentCart.paymentGroups],
                  // v26 ARMOR [STABLE-TRANSFER]: Transfer edilen ürünlerin 'başka masada taze ürün' gibi algılanmasını önlemek için durumları olduğu gibi kopyala
                  status: currentCart.status || 0
                };

                let clonedCurrentCart = Object.assign({}, currentCart);

                if (clonedCurrentCart.cartEntries) clonedCurrentCart.cartEntries = [];
                if (clonedCurrentCart.paymentGroups)
                  clonedCurrentCart.paymentGroups = [];
                if (clonedCurrentCart.orderPayments)
                  clonedCurrentCart.orderPayments = [];
                clonedCurrentCart.totalPrice = 0;
                clonedCurrentCart.totalPayedPrice = 0;

                this.$store.dispatch('selfservice/updateCartsById', [clonedCurrentCart]);

                this.$store.dispatch("selfservice/removeCart", clonedCurrentCart.id);
                this.$store.dispatch("selfservice/createNewCart", newCart);
                this.$store.dispatch("selfservice/setToUpdateEntry", null);
                this.$store.dispatch("selfservice/setCakeQuestioned", false);
                await setBranchCart({ value: newCart, tableId: newCart.tableId, branchTableUId: newCart.branchTableUId });
                await setBranchCart({
                  value: clonedCurrentCart,
                  tableId: clonedCurrentCart.tableId,
                  branchTableUId: clonedCurrentCart.branchTableUId,
                });
                // Note: transferCart API call for logging the move
                await transferCart(currentCart.tableId, id, allIds, description);
                this.$vs.notify({
                  color: "success",
                  title: "Masa Taşındı",
                  text: `${sourceTableName} numaralı masa ${number} numaralı masaya başarıyla taşındı.`,
                });
                this.moveTableModeDeactive();
                this.selectedTable = { id, number };
                this.showTableMap = false; // Ürün listesine geç
              }
            });
          }
        });
      } else {
        var carts = this.$store.getters["selfservice/getCarts"];

        // Mevcut cart'ların içinde ilgili tableId var mı diye kontrol et
        const existingCart = carts.find(
          (cart) => cart != null && cart.tableId === id
        );
        if (existingCart) {
          console.log(existingCart);
          // Eğer bu masa için zaten bir cart varsa, onu current cart olarak ayarla
          existingCart.name = number;
          this.$store.dispatch("selfservice/setCurrentCart", existingCart);
          this.$store.dispatch("selfservice/setToUpdateEntry", null);
          this.$store.dispatch("selfservice/setCakeQuestioned", false);
        } else {
          // Eğer bu masa için bir cart yoksa, yeni bir cart oluştur
          let newCart = {
            id: id,
            cartEntries: [],
            totalPrice: 0,
            active: true,
            tableId: id,
            tableNumber: number,
            paymentGroups: [],
            name: number,
            branchTableUId: uuid.v1(),
          };
          this.$store.dispatch("selfservice/createNewCart", newCart);
          this.$store.dispatch("selfservice/setToUpdateEntry", null);
          this.$store.dispatch("selfservice/setCakeQuestioned", false);
        }
        this.selectedTable = { id, number };
        this.showTableMap = true; // Ürün listesine geç
      }
    },
    async unSelectTable() {
      if (!this.isTableMove) {
        var carts = this.$store.getters["selfservice/getCarts"];
        let id = carts.length;
        if (carts.some(cart => cart && cart.name === "loss_cart")) {
          var lossCart = carts.find(cart => cart && cart.name === "loss_cart");
          this.$store.dispatch("selfservice/setCurrentCart", lossCart);
        } else {
          let newCart = {
            id: "n" + id.toString(),
            cartEntries: [],
            totalPrice: 0,
            active: true,
            name: "loss_cart",
            tableNumber: "n" + id.toString(),
            tableId: uuid.v1(),
            paymentGroups: [],
            notSeat: true,
          };
          this.$store.dispatch("selfservice/createNewCart", newCart);
          this.$store.dispatch("selfservice/setCurrentCart", newCart);
        }

        this.$store.dispatch("selfservice/setToUpdateEntry", null);
        this.$store.dispatch("selfservice/setCakeQuestioned", false);
      }

    },
    async editOrder() {
      this.editOrderMode = true;
      console.log("editOrder");
    },
    async moveTable(fromTableId, toTableId) {
      this.showDescriptionPrompt("Masa taşıma işlemi için lütfen bir açıklama giriniz.", async (description) => {
        var carts = this.$store.getters["selfservice/getCarts"];
        let fromCart = carts.find(
          (cart) => cart != null && cart.tableId === fromTableId
        );
        let toCart = carts.find(
          (cart) => cart != null && cart.tableId === toTableId
        );
        let clonedFromCart = _.cloneDeep(fromCart);
        let clonedToCart = _.cloneDeep(toCart);

        if (clonedFromCart.cartEntries && clonedToCart.cartEntries) {
          clonedToCart.cartEntries = clonedToCart.cartEntries.concat(_.cloneDeep(clonedFromCart.cartEntries));
        } else if (clonedFromCart.cartEntries) {
          clonedToCart.cartEntries = _.cloneDeep(clonedFromCart.cartEntries);
        }

        if (clonedFromCart.paymentGroups && clonedToCart.paymentGroups) {
          clonedToCart.paymentGroups = clonedToCart.paymentGroups.concat(
            _.cloneDeep(clonedFromCart.paymentGroups)
          );
        } else if (clonedFromCart.paymentGroups) {
          clonedToCart.paymentGroups = _.cloneDeep(clonedFromCart.paymentGroups);
        }

        if (clonedFromCart.orderPayments && clonedToCart.orderPayments) {
          clonedToCart.orderPayments = clonedToCart.orderPayments.concat(
            _.cloneDeep(clonedFromCart.orderPayments)
          );
        } else if (clonedFromCart.orderPayments) {
          clonedToCart.orderPayments = _.cloneDeep(clonedFromCart.orderPayments);
        }
        clonedToCart.totalPrice += clonedFromCart.totalPrice;
        clonedToCart.totalPayedPrice += clonedFromCart.totalPayedPrice;

        // Referans değeri korunması için null yerine boş dizi atanıyor
        if (clonedFromCart.cartEntries) clonedFromCart.cartEntries = [];
        if (clonedFromCart.paymentGroups) clonedFromCart.paymentGroups = [];
        if (clonedFromCart.orderPayments) clonedFromCart.orderPayments = [];
        clonedFromCart.totalPrice = 0;
        clonedFromCart.totalPayedPrice = 0;
        clonedFromCart.isFullTable = false;
        clonedToCart.isFullTable = true;

        this.$store.dispatch('selfservice/updateCartsById', [clonedFromCart, clonedToCart]);

        await setBranchCart({ value: clonedFromCart, tableId: clonedFromCart.tableId, branchTableUId: clonedFromCart.branchTableUId });
        await setBranchCart({ value: clonedToCart, tableId: clonedToCart.tableId, branchTableUId: clonedToCart.branchTableUId });
        const allIds = clonedFromCart.paymentGroups.map(pg => pg.rowIndex);
        await transferCart(fromTableId, toTableId, allIds, description);
        this.$vs.notify({
          color: "success",
          title: "Masa Taşındı",
          text: `Masa Taşındı`,
        });
        this.$refs.tableMap.fetchAreas();
        this.$store.dispatch("selfservice/setIsTableMove", false);
        this.isTableMove = false;
      });
    },
    async tableSelected(tableId) {
      if (tableId != null) {
        this.isTableOperationsMobileActive = true;
      }
      if (tableId) {
        const table = this.areas
          .flatMap((area) => area.buttons)
          .find((button) => button.id === tableId);
        await this.handleTableSelection({ id: table.id, number: table.name });
      }
      this.$refs.tableOperations.selectedTableId = tableId;
    },
    async startOrder(tableId) {
      this.lossMode = false;
      var table = this.areas
        .flatMap((area) => area.buttons)
        .find((button) => button.id === tableId);

      // Masa Kilitleme Denemesi
      try {
        await lockTable(tableId);
      } catch (error) {
        if (error.response && error.response.data && error.response.data.Message) {
          this.$vs.notify({
            color: "warning",
            title: "Masa Kullanımda",
            text: error.response.data.Message,
            iconPack: "feather",
            icon: "icon-alert-circle",
          });
        } else {
          this.$vs.notify({
            color: "danger",
            title: "Hata",
            text: "Masa kilitlenirken bir hata oluştu.",
          });
        }
        return; // İşlemi iptal et
      }

      this.isTableOperationsMobileActive = false;
      if (this.currentTab == "odeme") {
        this.handleTableSelection({ id: tableId, number: table.name });
      } else {
        if (!table.value.isFullTable && this.kuverSettings.isEnable) {
          console.log("kuverSettings", this.kuverSettings);
          this.isKuverPopupActive = true;
          console.log("table", table);
        }
        let newCart = {
          id: uuid.v1(),
          cartEntries: [],
          totalPrice: 0,
          active: true,
          tableNumber: uuid.v1(),
          tableId: uuid.v1(),
          paymentGroups: [],
          notSeat: true,
          name: table.name,
          realId: tableId,
        };
        this.$store.dispatch("selfservice/createNewCart", newCart);
        this.selectedTable = { id: tableId, number: table.name };
        this.showTableMap = false;
      }
    },
    async startPayment(tableId) {
      this.editOrderMode = false;

      // Masa Kilitleme Denemesi (Ödeme ekranına geçerken de kilitliyoruz)
      try {
        await lockTable(tableId);
      } catch (error) {
        if (error.response && error.response.data && error.response.data.Message) {
          this.$vs.notify({
            color: "warning",
            title: "Masa Kullanımda",
            text: error.response.data.Message,
            iconPack: "feather",
            icon: "icon-alert-circle",
          });
        }
        return; // İşlemi iptal et
      }

      this.isPaymentActive = true;
      var table = this.areas
        .flatMap((area) => area.buttons)
        .find((button) => button.id === tableId);
      this.isTableOperationsMobileActive = false;
      this.handleTableSelection({ id: tableId, number: table.name });

      // UUID ve BranchId bilgilerini masadan çek (Failsafe için) - [v26 ARMOR-HEAL]
      const cartsGetter = this.$store.getters['selfservice/getCarts'];
      const storeCart = cartsGetter ? cartsGetter.find(c => c && c.tableId === tableId) : null;
      let bTableUId = (table.value && table.value.branchTableUId) || (storeCart && storeCart.branchTableUId) || (this.currentCartGlobal && this.currentCartGlobal.tableId === tableId ? this.currentCartGlobal.branchTableUId : null);

      if (!bTableUId) {
        bTableUId = uuid.v1();
        console.warn("[ARMOR v26-HEAL] UUID was missing for Table " + tableId + ". Generated new one:", bTableUId);
        // Store'u da hemen güncelle ki reaktivite bozulmasın
        if (storeCart) {
          storeCart.branchTableUId = bTableUId;
          this.$store.dispatch('selfservice/updateCartsById', [storeCart]);
        }
      }

      const bId = (table.value && table.value.branchId) || (storeCart && storeCart.branchId) || (this.$store.state.AppActiveUser.branch ? this.$store.state.AppActiveUser.branch.id : null);

      console.log("[DEBUG v26] bTableUId identified for payment:", bTableUId);

      // Determine which payment component to show based on screen size
      if (this.isMobile) {
        // On mobile, show the mobile payment component
        this.$refs.orderListPaymentMobile.showPaymentScreen(bTableUId, bId);
      } else {
        // On desktop, show the regular payment component
        this.$refs.orderListPayment.showPaymentScreen(bTableUId, bId);
      }

      this.PlaceOrder();
    },
    async reserveTable(tableId) {
      var table = this.areas
        .flatMap((area) => area.buttons)
        .find((button) => button.id === tableId);
      var carts = this.$store.getters["selfservice/getCarts"];

      // Mevcut cart'ların içinde ilgili tableId var mı diye kontrol et
      const existingCart = carts.find(
        (cart) => cart != null && cart.tableId === tableId
      );
      if (existingCart) {
        existingCart.isFullTable = true;
        await reserveTable(tableId);
        let carts = (await getCarts()).data;
        if (carts.length > 0) {
          this.$store.dispatch("selfservice/setToCart", carts);
          const sSideCart = carts.find(c => c && c.tableId == tableId);
          if (sSideCart) {
            existingCart.branchTableUId = sSideCart.branchTableUId;
            existingCart.id = sSideCart.id;
            existingCart.rowVersion = sSideCart.rowVersion;
          }
        }
        await this.refreshBranchMap();
      } else {
        let newCart = {
          id: tableId,
          isFullTable: true,
          tableId: tableId,
          cartEntries: [],
          totalPrice: 0,
          active: true,
          paymentGroups: [],
          realId: tableId,
          branchTableUId: uuid.v1(),
        };
        this.$store.dispatch("selfservice/createNewCart", newCart);
        await setBranchCart({ value: newCart, tableId: newCart.tableId, branchTableUId: newCart.branchTableUId });
        let carts = (await getCarts()).data;
        if (carts.length > 0) {
          this.$store.dispatch("selfservice/setToCart", carts);
          const sSideCart = carts.find(c => c && c.tableId == tableId);
          if (sSideCart) {
            newCart.branchTableUId = sSideCart.branchTableUId;
            newCart.id = sSideCart.id;
            newCart.rowVersion = sSideCart.rowVersion;
            this.$store.dispatch("selfservice/updateCartById", newCart);
          }
        }
        await this.refreshBranchMap();
      }
      this.$refs.tableMap.fetchAreas();
      // Masa rezerve edildi bildirimi
      this.$vs.notify({
        color: "success",
        title: "Masa Rezerve Edildi",
        text: `${table.name} isimli masa başarıyla rezerve edildi.`,
      });
    },
    async unreserveTable(tableId) {
      var carts = this.$store.getters["selfservice/getCarts"];

      const existingCart = carts.find(
        (cart) => cart != null && cart.tableId === tableId
      );
      if (existingCart) {
        if (
          existingCart &&
          existingCart.paymentGroups &&
          existingCart.paymentGroups.length > 0
        ) {
          this.$vs.notify({
            color: "danger",
            title: "Hata",
            text: "Açık ödemesi olan masanın rezervasyonu iptal edilemez.",
          });
          return;
        }
        existingCart.isFullTable = false;
        await unReserveTable(tableId);
      } else {
        let newCart = {
          id: tableId,
          isFullTable: true,
          tableId: tableId,
          cartEntries: [],
          totalPrice: 0,
          active: true,
          paymentGroups: [],
          realId: tableId,
        };
        this.$store.dispatch("selfservice/createNewCart", newCart);
        await setBranchCart({ value: newCart, tableId: newCart.tableId, branchTableUId: newCart.branchTableUId });
      }
      this.$refs.tableMap.fetchAreas();
      this.$vs.notify({
        color: "success",
        title: "Masa Rezervasyonu İptal Edildi",
        text: `Masanın rezervasyonu iptal edildi.`,
      });
      //existingCart.isFullTable = false;
      //await setBranchCart({value:existingCart, tableId: tableId});
    },
    openCustomerScreen() {
      const primaryScreenWidth = window.screen.width;
      const features = `fullscreen=yes,menubar=no,toolbar=no,location=no,status=no,left=${primaryScreenWidth},top=${window.screen.height},width=0,height=0`;
      window.open(
        "/pages/customer-screen",
        "Lütfen ekrana tıklayınız...",
        features
      );
    },
    switchToTableMap() {
      // FIX [v22]: Haritaya dönerken aktif sepeti ve kullanıcı seçimlerini temizle
      this.$store.dispatch("selfservice/deactivateAllCarts");
      this.$store.dispatch("selfservice/setToUpdateEntry", null);
      this.$store.dispatch("selfservice/setSelectedProduct", null);
      this.$store.dispatch("selfservice/setPreSelectedProduct", null);
      this.isPaymentActive = false;
      this.isTableOperationsMobileActive = false;

      // v112: Masa haritasına dönerken tüm kilitleri temizle (Tekil kilit ve temiz başlangıç garantisi)
      releaseMyLocks().catch(err => console.error("releaseMyLocks error:", err));

      // Eğer bir masa seçiliyse kilidi kaldır (Geriye dönük uyum için tekil kaldırma da kalabilir)
      if (this.selectedTable && this.selectedTable.id) {
        releaseTable(this.selectedTable.id);
      }

      this.showTableMap = true;
      // Eğer varsa, mevcut seçili masayı temizle
      this.selectedTable = null;
      this.activeTab = "masalar";

      if (this.$refs.tableMap) {
        this.$refs.tableMap.fetchAreas();
      }
    },
    requestMergeTable(isTableMerge) {
      if (isTableMerge) {
        this.$store.dispatch("selfservice/setIsTableMerge", true);
        this.isTableMerge = true;
      } else {
        this.$store.dispatch("selfservice/setIsTableMerge", false);
        this.isTableMerge = false;
        if (this.fromTableIdGlobal != null) {
          const fromTable = this.areas
            .flatMap((area) => area.buttons)
            .find((button) => button.id === this.fromTableIdGlobal);

          if (fromTable) {
            fromTable.newTableNumber = "";
            this.$refs.tableMap.toggleButton(fromTable);
          }
          this.fromTableIdGlobal = null;
        }
      }
    },
    transferTable(isTableMove) {
      this.$store.dispatch("selfservice/setIsTableMove", isTableMove);
      this.isTableMove = isTableMove;
      this.showTableMap = true;
    },
    mergeTable(isTableMerge) {
      this.$store.dispatch("selfservice/setIsTableMerge", isTableMerge);
      this.isTableMerge = isTableMerge;
      this.showTableMap = true;
    },
    mergeTableAction(fromTableId, toTableId) {
      this.showDescriptionPrompt("Masa birleştirme işlemi için lütfen bir açıklama giriniz.", async (description) => {
        try {
          // Send request with description in the final API call
          try {
            // Birleştirilecek masadaki ürünleri topla
            var allCarts = this.$store.getters["selfservice/getCarts"];
            let fromCart = allCarts.find(c => c && c.tableId === fromTableId);
            const entryIds = fromCart && fromCart.cartEntries ? fromCart.cartEntries.map(e => e.id) : [];

            await addDiscountLog({
              tableId: toTableId,
              ids: entryIds,
              totalDiscount: 0,
              discountType: "Merge",
              actionType: "Merge",
              description: description
            });
          } catch (logError) {
            console.error("Merge log error:", logError);
          }
          await mergeCart(fromTableId, toTableId, description);
          let carts = (await getCarts()).data;

          if (carts.length > 0) {
            this.$store.dispatch("selfservice/setToCart", carts);
          }

          await this.refreshBranchMap();
          this.$store.dispatch("selfservice/setIsTableMerge", false);
          this.isTableMerge = false;

          this.$vs.notify({
            color: "success",
            title: "Yenilendi",
            text: "Masa Birleştirme Tamamlandı.",
          });
        } catch (error) {
          this.$vs.notify({
            color: "danger",
            title: "Hata",
            text: `Masa birleştirme sırasında bir hata oluştu: ${error.message || 'Bilinmeyen hata'}`,
          });
        }
      });
    },
    moveTableModeActive() {
      this.isTableMove = true;
      this.showTableMap = true;
    },
    moveTableModeDeactive() {
      this.isTableMove = false;
    },
    handleTabClick(tab) {
      this.activeTab = tab;
      if (this.activeTab == "masalar") {
        this.$store.dispatch("selfservice/setSelectedProduct", null);
        this.switchToTableMap();
      }
    },
    addCart(newTable) {
      let newCart = {
        id: newTable,
        cartEntries: [],
        totalPrice: 0,
        active: true,
        tableId: newTable,
        tableNumber: newTable,
        paymentGroups: [],
        name: newTable,
        branchTableUId: uuid.v1(),
      };
      this.$store.dispatch("selfservice/createNewCart", newCart);
    },
    async splitTable(tableId) {
      var carts = this.$store.getters["selfservice/getCarts"];
      let fromCart = carts.find(
        (cart) => cart != null && cart.tableId === tableId
      );

      // FIX: mergedIds bilgisini hem sepetten hem de masa haritasından kontrol et
      let mergedIds = [];
      if (fromCart && fromCart.mergedIds && fromCart.mergedIds.length > 0) {
        mergedIds = fromCart.mergedIds;
      } else {
        const allButtons = this.areas.flatMap((area) => area.buttons);
        const button = allButtons.find((b) => b.id === tableId);
        if (button && button.mergedIds && button.mergedIds.length > 0) {
          mergedIds = button.mergedIds;
        }
      }

      if (mergedIds.length > 0) {
        this.showDescriptionPrompt("Masa ayırma işlemi için lütfen bir açıklama giriniz.", async (description) => {
          // Merge edilmiş masaları ayır
          for (const mergedId of mergedIds) {
            let mergedCart = carts.find(
              (cart) => cart != null && cart.tableId === mergedId
            );
            if (mergedCart) {
              mergedCart.isMerged = false;
              mergedCart.mergedIds = [];
              this.$store.dispatch("selfservice/updateCart", mergedCart);
            }
          }

          // "Ayırma" işlemini logla (Masa ayrılmadan önce logla ki Cart hala aktif olsun)
          try {
            const entryIds = fromCart.cartEntries ? fromCart.cartEntries.map(e => e.id) : [];
            await addDiscountLog({
              tableId: fromCart.tableId, // Numeric ID'ye geri dön (Merge/Transfer ile tutarlı)
              ids: entryIds, // Boş dizi yerine mevcut ürünleri gönder
              totalDiscount: 0,
              discountType: "Separation",
              actionType: "Separation",
              description: description
            });
          } catch (logError) {
            console.error("Separation log error:", logError);
          }

          // Ana masayı güncelle ve teknik olarak ayır
          fromCart.isMerged = false;
          fromCart.mergedIds = [];
          await splitCart(fromCart.tableId);

          this.$store.dispatch("selfservice/updateCart", fromCart);
          this.$refs.tableMap.fetchAreas();
          this.$vs.notify({
            color: "success",
            title: "Masalar Ayrıldı",
            text: "Birleştirilmiş masalar başarıyla ayrıldı.",
          });
        });
      } else {
        this.$vs.notify({
          color: "warning",
          title: "İşlem Yapılamadı",
          text: "Seçili masada birleştirilmiş masa bulunamadı.",
        });
      }
    },
    showAdisyon(tableId) {
      this.editOrderMode = false;
      this.totalDiscountPrice = 0;
      this.totalOriginPrice = 0;
      this.orderBillEntries = [];
      console.log("showAdisyon", tableId);
      var carts = this.$store.getters["selfservice/getCarts"];
      const existingCart = carts.find(
        (cart) => cart != null && cart.tableId === tableId
      );
      this.$store.dispatch("selfservice/setCurrentCart", existingCart);
      this.isAdisyonActive = true;
    },
    handleLongPressTable(tableId) {
      console.log("Long press table triggered:", tableId);
      // v121: Automatically open the bill popup on long press
      this.showAdisyon(tableId);
    },
    lossModeActive() {
      this.isTableOperationsMobileActive = false;
      this.lossMode = true;
      this.showTableMap = false;
    },
    calculateTotalOriginPrice: function (selectedGroups) {
      let selectedPrice = 0;
      selectedGroups.forEach((item) => {
        item.entries.forEach((entry) => {
          // Ara Toplam için her zaman originPrice kullanılmalı. 
          // Eğer yoksa (indirim uygulanmamış demektir) price kullanılır.
          selectedPrice += (entry.originPrice || entry.price || 0);
        });
      });
      return Math.round(selectedPrice * 100) / 100;
    },

    setBillExtras(extras) {
      if (!extras || !Array.isArray(extras)) return [];

      // v118.Alpha-Final-11: Adisyon çıktısı ile senkronizasyon için düzleştirme (flattening) kaldırıldı.
      // Sadece 0-adetli OLMAYAN ekstraları (veya varyantı olanları) filtrele ama yapıyı koru.
      return extras.filter(ex => {
        const qty = parseFloat(ex.quantity || ex.Quantity || 0);
        const variants = ex.variants || ex.Variants || [];

        // Eğer miktarı > 0 ise veya miktarı 0 olsa bile içinde seçili varyant varsa göster
        return qty > 0 || (variants.length > 0 && variants.some(v => parseFloat(v.quantity || v.Quantity || 0) > 0));
      }).map(ex => {
        // Varyantları da kendi içinde filtrele
        const exCopy = JSON.parse(JSON.stringify(ex));
        const variants = exCopy.variants || exCopy.Variants || [];
        if (variants.length > 0) {
          const filteredV = variants.filter(v => parseFloat(v.quantity || v.Quantity || 0) > 0);
          exCopy.variants = filteredV;
          exCopy.Variants = filteredV;
        }
        return exCopy;
      });
    },
    sumOfExtraPrices(extras) {
      let sum = 0;
      extras.forEach((x) => {
        if (x.variants != null && x.variants.length > 0) {
          x.variants.forEach((y) => {
            sum += y.price * y.quantity;
          });
        } else {
          sum += x.price * x.quantity;
        }
      });
      return sum;
    },
    cleanProductName(name) {
      if (!name) return '';
      let n = name.replace(/\s\d{2}:\d{2}$/, '');
      let separator = n.includes('->') ? '->' : (n.includes('>') ? '>' : null);
      
      if (separator) {
        const parts = n.split(separator).map(s => s.trim());
        const main = parts[0];
        // Filter out 'Adet' or parts that just repeat the main product name (matching Printer.vue logic)
        const filteredParts = parts.filter((part, index) => {
          if (index === 0) return true;
          const p = part.toLowerCase();
          return p !== 'adet' && !main.toLowerCase().includes(p) && !p.includes(main.toLowerCase());
        });
        return filteredParts.join('->');
      }
      return n;
    },
    printAdisyon(rowIndexes = [], copyCount = 1) {
      if (this.isTransaction) return;
      this.isTransaction = true;
      console.log("printAdisyon (SignalR)", rowIndexes, copyCount);
      this.preparePrintData(rowIndexes);
      this.triggerManualPrint(copyCount, false, true); // forceSignalR = true
      
      const rawCart = this.$store.getters["selfservice/getCurrentCart"];
      const sid = this.$store.getters["selfservice/getSid"];

      // v135: Mark as printed in the backend immediately
      if (sid) {
        markAdisyonPrinted(sid).catch(e => console.error("markAdisyonPrinted error:", e));
      }

      // v132: Set printed flag for table map icon with high-safety cloning and explicit store update
      if (rawCart && rawCart.tableId) {
        const cartClone = JSON.parse(JSON.stringify(rawCart));
        cartClone.isAdisyonPrinted = true;
        
        // v133: Update local store immediately to trigger reactivity
        this.$store.dispatch("selfservice/updateCartsById", [cartClone]);
      }
      
      setTimeout(() => {
        this.isTransaction = false;
      }, 2000);
    },

    printAdisyonManual(rowIndexes = [], copyCount = 1) {
      if (this.isTransaction) return;
      this.isTransaction = true;
      console.log("printAdisyonManual (Browser)", rowIndexes, copyCount);
      this.preparePrintData(rowIndexes);
      // v85: Manuel yazdır için 4. parametre olarak forceBrowser=true gönrderiyoruz
      this.triggerManualPrint(copyCount, false, false, true);

      const rawCart = this.$store.getters["selfservice/getCurrentCart"];
      const sid = this.$store.getters["selfservice/getSid"];

      // v135: Mark as printed in the backend immediately (Essential for browser prints!)
      if (sid) {
        markAdisyonPrinted(sid).catch(e => console.error("markAdisyonPrinted error:", e));
      }

      // v132: Set printed flag for table map icon with high-safety cloning and explicit store update
      if (rawCart && rawCart.tableId) {
        const cartClone = JSON.parse(JSON.stringify(rawCart));
        cartClone.isAdisyonPrinted = true;
        
        // v133: Update local store immediately to trigger reactivity
        this.$store.dispatch("selfservice/updateCartsById", [cartClone]);
      }
      
      setTimeout(() => {
        this.isTransaction = false;
      }, 2000);
    },

    preparePrintData(rowIndexes = []) {
      const carts = this.$store.getters["selfservice/getCarts"];
      let orderBillEntries = [];
      // FIX [v50]: Eğer currentCartGlobal (Adisyon Popup verisi) varsa onu kullan, yoksa Store sepetini kullan
      let afterPrintCart = this.currentCartGlobal || this.$store.getters["selfservice/getCurrentCart"];

      let allCartEntries = [...(afterPrintCart.cartEntries || afterPrintCart.entries || [])];
      let allPaymentGroups = [...(afterPrintCart.paymentGroups || [])];

      if (afterPrintCart.mergedIds && Array.isArray(afterPrintCart.mergedIds)) {
        afterPrintCart.mergedIds.forEach(mid => {
          const mCart = carts.find(c => c && c.id === mid);
          if (mCart) {
            if (mCart.cartEntries) allCartEntries.push(...mCart.cartEntries);
            if (mCart.paymentGroups) allPaymentGroups.push(...mCart.paymentGroups);
          }
        });
      }

      let filteredCartEntries = allCartEntries;
      let filteredPaymentGroups = allPaymentGroups;

      // Filter entries if rowIndexes is provided and not empty
      if (rowIndexes && rowIndexes.length > 0) {
        filteredPaymentGroups = filteredPaymentGroups.filter(pg => rowIndexes.includes(pg.rowIndex));
        const validEntryIds = filteredPaymentGroups.flatMap(pg => pg.entries.map(entry => entry.id));
        filteredCartEntries = filteredCartEntries.filter(entry => validEntryIds.includes(entry.id));
      }

      // v118.V36 [GLOBAL-CANCELLATION-FILTER]: Yazdırma öncesi tüm sepeti tarayarak iptal sebeplerini topla
      const globalForbiddenWords = (filteredCartEntries || []).reduce((acc, en) => {
        if (en && en.description) acc.add(en.description.trim().toLowerCase());
        if (en && en.note) acc.add(en.note.trim().toLowerCase());
        if (en && en.Note) acc.add(en.Note.trim().toLowerCase());
        return acc;
      }, new Set());

      filteredCartEntries.forEach((tr) => {
        const trCopy = JSON.parse(JSON.stringify(tr));
        const targetRecipe = trCopy.recipe || trCopy.Recipe || trCopy.recipeSteps || trCopy.RecipeSteps;
        const steps = targetRecipe ? (targetRecipe.steps || targetRecipe.Steps || targetRecipe.recipeSteps || targetRecipe.RecipeSteps || []) : [];

        // v118.V36 [STRICT-MATERIAL]: Silinebilir içerikleri veya özel eklemeleri tut, sabit kalemleri gizle.
        const filteredSteps = Array.isArray(steps) ? steps.filter(
          (x) => x && (x.name || x.Name || x.productName || x.ProductName) && 
                  (x.isRemovable || x.IsRemovable || (!(x.isDefault || x.IsDefault) && (x.selected || x.Selected)) || x.isRemoved || x.IsRemoved) &&
                  !globalForbiddenWords.has((x.name || "").trim().toLowerCase()) && (
            (x.isRemoved || x.IsRemoved || x.is_removed || x.is_Removed || ((x.isDefault || x.IsDefault) && !(x.selected || x.Selected))) // Çıkarma
            ||
            ((x.selected || x.Selected) && !(x.isDefault || x.IsDefault)) // Ekleme
            ||
            (x.isDefault || x.IsDefault) // Silinebilir-Varsayılanlar (Örn: Domates - listede normal görünmeli)
          )
        ).map(step => {
          const _isRemoved = !!(step.isRemoved || step.IsRemoved || step.is_removed || step.is_Removed || ((step.isDefault || step.IsDefault) && !(step.selected || step.Selected)));
          step.isRemoved = _isRemoved;

          const rawMat = step.rawMaterial || step.RawMaterial || step.raw_material;
          const pName = step.productName || step.ProductName || (step.product && (step.product.name || step.product.Name));
          step.name = (rawMat && (rawMat.name || rawMat.Name)) ? (rawMat.name || rawMat.Name) :
            (pName ? pName : (step.name || step.Name || "Malzeme"));
          return step;
        }) : [];

        if (trCopy.recipe) trCopy.recipe.steps = filteredSteps;
        if (trCopy.Recipe) trCopy.Recipe.Steps = filteredSteps;

        orderBillEntries.push({
          productId: trCopy.productId || trCopy.ProductId,
          childProductId: trCopy.childProductId || trCopy.ChildProductId,
          productQuantity: parseFloat(trCopy.quantity || trCopy.Quantity || 1),
          productName: this.cleanProductName(trCopy.productName || trCopy.ProductName),
          isTime: trCopy.isTime,
          totalHour: trCopy.totalHour,
          userName: trCopy.userName,
          time: trCopy.time,
          createdDate: trCopy.createdDate,
          steps: filteredSteps,
          recipeSteps: filteredSteps,
          variantItems: filteredSteps.filter(x => !x.isRemoved && x.selected && !x.isDefault),
          extras: this.setBillExtras(trCopy.extras || trCopy.Extras),
          price: trCopy.price || trCopy.Price,
          originPrice: trCopy.originPrice || trCopy.OriginPrice || trCopy.price || trCopy.Price,
        });
      });

      // UI listesinde aktif personeli göster
      filteredPaymentGroups.forEach(tr => {
        if (tr.entries) {
          tr.entries.forEach(entry => {
            if (!entry.userName || entry.userName === 'Sistem') {
              const activePers = this.$store.getters["selfservice/getActivePersonal"];
              entry.userName = activePers ? activePers.name : 'Sistem';
            }
          });
        }
      });

      this.orderBillEntries = orderBillEntries;
      this.orderBillNo = this.$store.getters["selfservice/getCurrentCart"].orderNo;
      this.totalOriginPrice = afterPrintCart.totalOriginPrice;
      this.totalDiscountPrice = afterPrintCart.totalDiscountPrice;

      this.currentCartGlobal.branchName = this.$store.state.AppActiveUser.branch.name;
      this.currentCartGlobal.entries = this.orderBillEntries;
      this.currentCartGlobal.orderNo = this.orderBillNo;
      this.currentCartGlobal.printerName = this.printerSettings.mainPrinterName;
      this.currentCartGlobal.paymentGroups = filteredPaymentGroups;
      this.currentCartGlobal.branchId = this.$store.state.AppActiveUser.branch.id;
    },
    showDescriptionPrompt(text, callback) {
      this.descriptionPromptText = text;
      this.descriptionPromptCallback = callback;
      this.pendingDescription = "";
      this.isDescriptionLoading = false;
      this.isDescriptionPromptActive = true;
    },
    async confirmDescriptionPrompt() {
      if (this.pendingDescription && this.pendingDescription.trim() !== "") {
        this.isDescriptionLoading = true;
        try {
          if (this.descriptionPromptCallback) {
            await this.descriptionPromptCallback(this.pendingDescription);
          }
        } finally {
          this.isDescriptionLoading = false;
          this.isDescriptionPromptActive = false;
          this.pendingDescription = "";
          this.descriptionPromptCallback = null;
        }
      }
    },
    cancelDescriptionPrompt() {
      this.isDescriptionPromptActive = false;
      this.pendingDescription = "";
      this.descriptionPromptCallback = null;
    },
    triggerManualPrint(copyCount = 1, isFinal = null, forceSignalR = false, forceBrowser = false) {
      this.printeractive = true;
      this.$nextTick(() => {
        if (this.$refs.printer1) {
          // FIX [v50]: Yerel verileri printer'a aktar (Adisyon yazdırma için kritik)
          const gCart = this.currentCartGlobal || {};
          const storeCart = this.$store.getters["selfservice/getCurrentCart"] || {};

          this.$refs.printer1.localTotalPrice = gCart.totalPrice;
          this.$refs.printer1.localTotalOriginPrice = gCart.totalOriginPrice;
          this.$refs.printer1.localTotalDiscountPrice = gCart.totalDiscountPrice;
          this.$refs.printer1.localOrderPayments = gCart.orderPayments;
          this.$refs.printer1.localTotalPayedPrice = gCart.realPaymentsTotal; // NET Ödeme
          this.$refs.printer1.localLeftPrice = gCart.leftPrice;

          this.$refs.printer1.localTableName = gCart.cartName || (this.$store.getters["selfservice/getCurrentCart"] ? this.$store.getters["selfservice/getCurrentCart"].name : "");
          this.$refs.printer1.localActivePersonal = this.$store.getters["selfservice/getActivePersonal"] ? this.$store.getters["selfservice/getActivePersonal"].name : "";


          // v85: forceBrowser parametresini ilet
          this.$refs.printer1.printOrders(copyCount, isFinal, forceSignalR, forceBrowser);
          setTimeout(() => {
            this.printeractive = false;
          }, 2000);
        }
      });
    },

    checkScreen() {
      this.isMobile = window.innerWidth <= 768;
    },
    formatAdisyonDate(entry) {
      if (!entry) return "";
      try {
        let createdDateStr = null;

        // 1. Önce ana sepetten (cartEntries) bu entry'nin ID'si ile EN GÜNCEL tarihi bulmaya çalış (Source of Truth)
        if (entry.id) {
          const cart = this.$store.getters["selfservice/getCurrentCart"];
          if (cart && cart.cartEntries) {
            const originalEntry = cart.cartEntries.find(x => x && (x.id === entry.id || x.realId === entry.id));
            if (originalEntry && originalEntry.createdDate) {
              createdDateStr = originalEntry.createdDate;
            }
          }
        }

        // 2. Eğer ana sepette bulunamadıysa (yeni eklenen veya silinmiş kalemler), kendi üzerindeki createdDate'i kullan
        if (!createdDateStr) {
          createdDateStr = entry.createdDate;
        }

        // 3. Bulunan createdDate veya entry içindeki time'ı kontrol et
        const sources = [createdDateStr, entry.time].filter(Boolean);
        for (const src of sources) {
          // Türk formatı (05.03.2024) manuel parçalama
          if (typeof src === 'string' && src.includes('.')) {
            const parts = src.split(/[.\s:]/);
            if (parts.length >= 2 && parts[0].length <= 2 && parts[1].length <= 2) {
              return `${parts[0].padStart(2, '0')}/${parts[1].padStart(2, '0')}`;
            }
          }

          // ISO format (2026-03-06T10:47:08.839812Z) kontrolü - Saat kaymasını önlemek için manuel parçalama
          if (typeof src === 'string' && src.includes('T')) {
            try {
              const [datePart, timePart] = src.split('T');
              const dParts = datePart.split('-'); // 2026, 03, 06
              const tParts = timePart.split(':'); // 10, 47, 08...
              if (dParts.length >= 3 && tParts.length >= 2) {
                return `${dParts[2].padStart(2, '0')}/${dParts[1].padStart(2, '0')} ${tParts[0].padStart(2, '0')}:${tParts[1].padStart(2, '0')}`;
              }
            } catch (e) {
              console.error("Manual ISO parse error:", e);
            }
          }

          const d = new Date(src);
          if (!isNaN(d.getTime()) && d.getFullYear() > 2000) {
            const day = String(d.getDate()).padStart(2, '0');
            const month = String(d.getMonth() + 1).padStart(2, '0');
            const hh = String(d.getHours()).padStart(2, '0');
            const mm = String(d.getMinutes()).padStart(2, '0');
            return `${day}/${month} ${hh}:${mm}`;
          }
        }
      } catch (e) {
        console.error("formatAdisyonDate error:", e);
      }
      return "";
    },
    selectPos(pos) {
      // Handle POS selection
      this.$store.dispatch("selfservice/setSelectedPos", pos.id);
      this.isPosSelectionActive = false;
      this.$vs.notify({
        color: 'success',
        title: 'POS Seçildi',
        text: `${pos.name} seçildi.`
      });
    },
    cleanProductName(name) {
      if (!name) return '';
      let n = name.replace(/\s\d{2}:\d{2}$/, '');
      let separator = n.includes('->') ? '->' : (n.includes('>') ? '>' : null);

      if (separator) {
        const parts = n.split(separator).map(s => s.trim());
        const main = parts[0];
        const filteredParts = parts.filter((part, index) => {
          if (index === 0) return true;
          const p = part.toLowerCase();
          return p !== 'adet' && !main.toLowerCase().includes(p) && !p.includes(main.toLowerCase());
        });
        return filteredParts.join('->');
      }
      return n;
    },
    handleEviction() {
      // v112.1: Masadan atılma/tahliye işlemi
      this.isScreenLock = true; // Ekranı kilitle (işlem yapılmasını engelle)

      this.$vs.notify({
        color: "danger",
        title: "Masadan Atıldınız",
        text: "Masa kilidiniz bir yönetici tarafından kaldırıldı. Ana haritaya yönlendiriliyorsunuz.",
        fixed: true,
        iconPack: 'feather',
        icon: 'icon-alert-triangle'
      });

      // 3 saniye sonra haritaya yönlendir
      setTimeout(() => {
        this.isScreenLock = false;
        this.switchToTableMap();
      }, 3000);
    }
  },
  created: async function () {
    // v112: Sayfa ilk yüklendiğinde kullanıcının tüm kilitlerini temizle
    releaseMyLocks().catch(err => console.error("Initial releaseMyLocks error:", err));

    window.addEventListener("visibilitychange", this.handleVisibilityChange);
    this.checkScreen();
    window.addEventListener("resize", this.checkScreen);
    this.productList = null;
    await this.checkPosDevice();
    if (this.isPosEnabled) this.connectPos(false);
    this.fetchCategories();
    this.fetchUsers();
    await this.fetchKuverSettings();
    let carts = await getCarts();
    console.log("carts", carts);
    if (carts.data.length > 0) {
      this.$store.dispatch("selfservice/setToCart", carts.data);
    }
    var printerSettingResponse = (await getPrinterSetting()).data;
    this.$store.dispatch(
      "selfservice/setPrinterSettings",
      printerSettingResponse
    );
    this.fetchLastBillId();
    this.getPaymentMethodList();
    this.getNavigationQuestionForSale();
    let checkAuth = Cookies.get(CookieKeys.AUTH_KEY);
    checkAuth ? (this.isAuth = true) : this.$router.push("/pages/login");
    this.isScreenLock = false;
    
    // Ayarları paralel ve bloklamayan şekilde yükle
    Promise.all([
      getDayReportEnable(),
      this.getOpenClose()
    ]).then(([dayReportResponse]) => {
      this.dayReportIsEnable = dayReportResponse && dayReportResponse.data;
      
      if (this.dayReportIsEnable) {
        getIsDayOpening().then(isDayOpening => {
          if (isDayOpening.data == 0) {
            this.$refs.topofthedayscreenref.isActive = true;
          }
          if (isDayOpening.data == 1) {
            this.$refs.dayclosescreenref.isOldClose = true;
            this.$refs.dayclosescreenref.lastOpenDate = this.openClose.lastOpenDate;
            this.$refs.dayclosescreenref.isActive = true;
          }
        });

        getIsDayInterim(); // Ara rapor kontrolü (sessizce çalışabilir)
        
        this.timerId = setInterval(this.checkClosingTime, 120000);
      } else {
        // v118.F1: Gün sonu raporu kapalıysa arkada sessiz gün başlat
        this.checkAndStartSilentDay();
      }
    }).catch(err => {
      console.error("SelfService initialization error:", err);
    });

    this.inactivityTime();
    // Socket bağlantısını kur
    this.connection = new HubConnectionBuilder()
      .withUrl(process.env.VUE_APP_ROOT_API + '/hub' + '?webBranchId=' + this.$store.state.AppActiveUser.branch.id, {
        transport: HttpTransportType.WebSockets,
        skipNegotiation: true
      })
      .withAutomaticReconnect()
      .build();

    // Bağlantıyı başlat
    await this.connection.start();

    // Yeniden bağlantı durumunu dinle
    this.connection.onreconnected((connectionId) => {
      console.log('Yeniden bağlantı başarılı, Yeni Connection ID:', connectionId);
      this.$refs.tableMap.fetchAreas();
    });

    // Timeout ayarları
    this.connection.serverTimeoutInMilliseconds = 40000;
    this.connection.keepAliveIntervalInMilliseconds = 15000;
    this.connection.on("refresh-orders", message => {
      this.$refs.tableMap.fetchAreas();
    });
    this.connection.on("change-cart", message => {
      if (this.isMobile) {
        this.$refs.orderListPaymentMobile.changeCart(message);
      } else {
        this.$refs.orderListPayment.changeCart(message);
      }
    });

    // v112.1 Fix: Masa tahliye (kick-out) dinleyicisi (Tip bağımsız kontrol ve loglar eklendi)
    this.connection.on("lock-released", (tableId, prevUserId) => {
      const currentUserId = this.$store.state.AppActiveUser.id;
      console.log("[SignalR] lock-released received:", { tableId, prevUserId, currentUserId, showTableMap: this.showTableMap });

      // Eğer kullanıcı şu an masadaysa ve kilidi başkası tarafından kaldırıldıysa (Tip bağımsız karşılaştırma '==')
      if (!this.showTableMap && this.selectedTable && this.selectedTable.id == tableId && prevUserId == currentUserId) {
        console.warn("[SignalR] Eviction triggered for table:", tableId);
        this.handleEviction();
      }
    });
    // this.connection.on("PrintOrder", message => {
    //   console.log("PrintOrder",message);
    //   let orderBillEntries = [];
    //   message.cartEntries.forEach((tr) => {
    //     orderBillEntries.push({
    //       productId: tr.productId,
    //       childProductId: tr.childProductId,
    //       productQuantity: tr.quantity,
    //       productName: tr.productName,
    //       recipe: tr.recipe,
    //       variantItems: tr.recipe.steps.filter(
    //         (x) => x.selected == true && x.isDefault == false
    //       ),
    //       extras: this.setBillExtras(tr.extras),
    //       price: tr.price / tr.quantity - this.sumOfExtraPrices(tr.extras),
    //       rawProduct: tr.rawProduct,
    //       note: tr.note,
    //     });
    //   });
    //   fetch("http://localhost:5000" + "/api/print-text", {
    //           method: "POST",
    //           referrerPolicy: "unsafe-url",
    //           rejectUnauthorized: false,
    //           headers: {
    //             Accept: "application/json",
    //             "Content-Type": "application/json",
    //           },
    //           body: JSON.stringify({
    //             PrinterName: message.printerName,
    //             Entries: orderBillEntries,
    //             Text: "test123",
    //             OrderNo: message.orderNo,
    //             Branch: this.$store.state.AppActiveUser.branch.name,
    //             Cart: message,
    //           }),
    //         }).catch((error) => {
    //           console.error("Yazıcı hatası:", error);
    //           alert("Yazıcı hatası:" + error);
    //           // İsteğe bağlı olarak hata bildirimi göster ama akışa devam et
    //         });
    // });
  },
  mounted() {
    this.refreshMainScroll();
    // Sayfa ilk açıldığında layout'un tam oturması için resize tetikle
    setTimeout(() => {
      window.dispatchEvent(new Event('resize'));
    }, 100);
  },
  beforeCreate: function () {
    if (!selfServiceStore.isRegistered) {
      this.$store.registerModule("selfservice", selfServiceStore);
      selfServiceStore.isRegistered = true;
    }
  },
  beforeDestroy: async function () {
    window.removeEventListener("visibilitychange", this.handleVisibilityChange);
    // Socket bağlantısını kapat
    if (this.connection) {
      try {
        await this.connection.stop();
        console.log('Socket bağlantısı başarıyla kapatıldı');
      } catch (err) {
        console.error('Socket bağlantısı kapatılırken hata:', err);
      }
    }

    // Diğer cleanup işlemleri
    window.removeEventListener("resize", this.checkScreen);
    if (this.timerId) {
      clearInterval(this.timerId);
    }
  },
};